<template>
  <div>
    <ViewTemplateWithSalveCancel :panel="panel">
      <div slot="content-main">
        <InvoiceCreateUpdate :formName="panel.formName" />
      </div>
    </ViewTemplateWithSalveCancel>
  </div>
</template>

<script>

import ViewTemplateWithSalveCancel from "@nixweb/nixloc-ui/src/component/template/ViewTemplateWithSalveCancel";
import InvoiceCreateUpdate from '../../../components/modules/billing/invoice/InvoiceCreateUpdate.vue'

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "InvoiceCreateUpdateView",
  components: {
    ViewTemplateWithSalveCancel,
    InvoiceCreateUpdate
  },
  data() {
    return {
      id: this.$route.params.id,
      panel: {
        module: "Faturamento",
        title: "Fatura",
        formName: "rentCreateUpdate",
        showFilter: false,
        showSearch: false,
        showButtons: false,
      },
    };
  },
  computed: {
    ...mapGetters("generic", ["event"]),
  },
  methods: {
    ...mapMutations("generic", ["removeLoading"]),
  
  },
};
</script>
